import React from "react";
import StripeBadgeImg from "../../assets/img/stripe-badge.png";

export default function StripeCheckoutBadge({ className = ""}) {
  return (
    <div className={`stripe-badge-image ${className}`}>
        <img src={StripeBadgeImg} alt="Stripe Badge" />
    </div>
  );
}
